module.exports = __webpack_public_path__ + "static/media/temp1.f2894196.png";